import { Hits, InstantSearch, useSearchBox } from "react-instantsearch";
import AlgoliaSearchBox from "@components/search/algolia-search-box";
import AlgoliaAutocompleteHit from "@components/search/algolia-autocomplete-hit";
import { useMediaQuery } from "@repo/ui/lib/use-media-query-hook";
import { useAlgoliaClient } from "@/algolia/algolia-provider";
import { ALGOLIA_PRODUCTS_INDEX } from "@/algolia/search-url";

function AlgoliaHits() {
  const { query } = useSearchBox();

  if (query?.length > 2) {
    return (
      <Hits
        hitComponent={AlgoliaAutocompleteHit}
        classNames={{
          root: "w-full absolute left-0 right-0 top-full z-50 mt-5",
          list: "h-[300px] overflow-y-scroll flex flex-col gap-2 rounded-[30px] border p-6 divide-y bg-primary-white dark:bg-secondary-black drop-shadow-product-image",
          item: "py-4 max-md:py-0",
        }}
      />
    );
  }

  return <></>;
}

export default function AlgoliaSearch({
  onSearch,
  onSuggestionSelect,
}: {
  onSearch: (e: React.FormEvent<HTMLFormElement>) => void;
  onSuggestionSelect?: (query: string) => void;
}) {
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const searchClient = useAlgoliaClient();

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={ALGOLIA_PRODUCTS_INDEX}
    >
      <div className="relative w-full">
        <AlgoliaSearchBox
          onSearch={onSearch}
          onSuggestionSelect={onSuggestionSelect}
          autofocus={isDesktop ? true : false}
        />

        {/*<AlgoliaHits />*/}
      </div>
    </InstantSearch>
  );
}
